export const SET_SHOWSNACKBAR = "SET_SHOWSNACKBAR";

export interface ShowSnackbar {
  showSnackbar: boolean;
  message: string;
}
